import { useCredentialsQuery } from '../data-access/queries/useCredentialsQueries';
import { useMe } from '../hooks/useMe';

export const useUser = () => {
	const { refetchMe } = useMe({ enabled: false });
	const { refetchCredentials } = useCredentialsQuery();

	const refetchUser = () => {
		refetchMe();
		refetchCredentials();
	};

	return {
		refetchUser
	};
};
